import React, { Component } from 'react';
const config = require('../../../package.json');

export default class About extends Component {
    render() {
        return (
            <div>
                <p>Application: {config.name}</p>
                <p>Version: {config.version}</p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/About/index.js